// Test friendly wrapper
export default function navigate(path: string) {
  window.location.href = path;
}
